import React from "react";
import { useStyles } from "./styles";

export const NewsWidgetHeader = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <>
      <div className={classes.header} ref={ref}>
        {children}
      </div>
    </>
  );
};
NewsWidgetHeader.muiName = "NewsWidgetHeader";
NewsWidgetHeader.displayName = "NewsWidgetHeader";

export default NewsWidgetHeader;

export * from "./NewsWidgetTitle";
export * from "./NewsWidgetMore";
